var React = require('react');

function FancyArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.2753 7.33331C24.2753 11.6662 27.7337 15.1787 32 15.1787V15.4583V15.7379V16.2621V16.5416V16.8212C27.7338 16.8212 24.2753 20.3337 24.2753 24.6666H23.2086C23.2086 21.0582 25.3163 17.9497 28.3495 16.5416L0 16.5416V15.4583L28.3495 15.4583C25.3163 14.0503 23.2086 10.9418 23.2086 7.33331H24.2753Z","fill":"currentColor"}));
}

FancyArrowRightInline.defaultProps = {"className":"w-full h-auto pointer-events-none","viewBox":"0 0 32 32","fill":"none"};

module.exports = FancyArrowRightInline;

FancyArrowRightInline.default = FancyArrowRightInline;
